export enum ActivityType {
  Assignment = 'ASSIGNMENT',
  Status = 'STATUS',
  Comment = 'COMMENT',
  Photo = 'PHOTO',
  Document = 'DOCUMENT',
}
